import {AbstractAdminEntityService} from "./AbstractAdminEntityService";
import {AffiliatesSettings, ListResponse, Player} from "../http/protocol";
import {HttpService} from "../http/HttpService";


export class AffiliatesService extends AbstractAdminEntityService<AffiliatesSettings,ListResponse> implements AffiliatesService{
    constructor(http: HttpService) {
        super("/affiliates", http);
    }


    getSettings(): Promise<AffiliatesSettings> {
        return this.http.get(`${this.entityPath}/settings`);
    }


    saveSettings(settings: AffiliatesSettings):Promise<AffiliatesSettings> {
        return this.http.put<{},{}>(`${this.entityPath}/settings`, settings);
    }


    //Reports
    getPayoutsAll(request:{}):Promise<{}> {
        return this.http.post(this.entityPath +'/payouts/all', request);
    }

    getAffiliateRevenue(date:string, affiliateId:number):Promise<{}> {
        return this.http.get(`${this.entityPath}/revenue/player/month/${date}/${affiliateId}`);
    }

    setAffiliate(affiliateId: number, player: Player): Promise<{}> {
        return this.http.post(`${this.entityPath}/${affiliateId}/players`, player);
    }

    getAffiliatePlayersAll(affiliateId: number,request:{}):Promise<{}> {
        return this.http.post(`${this.entityPath}/list-players/${affiliateId}`, request);
    }

    getAffiliateByCashoutUserId(cashoutUserId: number,request:{}):Promise<{}> {
        return this.http.post(`${this.entityPath}/cashoutId/${cashoutUserId}`, request);
    }

}